import { Form, Head, usePage } from "@inertiajs/react"

import InputError from "@/components/input-error"
import TextLink from "@/components/text-link"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Separator } from "@/components/ui/separator"
import { Spinner } from "@/components/ui/spinner"
import AuthLayout from "@/layouts/auth-layout"
import { newIdentityPasswordResetPath, signInPath, signUpPath } from "@/routes"

export default function Login() {
  const { props } = usePage()
  const isMobileApp = (props.app as { mobile_app?: boolean })?.mobile_app

  const handleGoogleLogin = async () => {
    if (isMobileApp) {
      const { handleNativeGoogleLogin } = await import("@/lib/native-auth")
      await handleNativeGoogleLogin()
    } else {
      window.location.assign("/auth/google_oauth2")
    }
  }

  return (
    <AuthLayout
      title="Iniciar sesión"
      description="Ingresá tu email y contraseña para acceder"
    >
      <Head title="Iniciar sesión" />

      <div className="flex flex-col gap-6">
        <Button
          type="button"
          variant="outline"
          className="w-full"
          onClick={handleGoogleLogin}
        >
          <svg className="mr-2 h-4 w-4" viewBox="0 0 24 24">
            <path
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
              fill="#4285F4"
            />
            <path
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              fill="#34A853"
            />
            <path
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              fill="#FBBC05"
            />
            <path
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              fill="#EA4335"
            />
          </svg>
          Iniciar sesión con Google
        </Button>

        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <Separator className="w-full" />
          </div>
          <div className="relative flex justify-center text-xs uppercase">
            <span className="bg-background text-muted-foreground px-2">o</span>
          </div>
        </div>

        <Form
          method="post"
          action={signInPath()}
          resetOnSuccess={["password"]}
          className="flex flex-col gap-6"
        >
          {({ processing, errors }) => (
            <>
              <div className="grid gap-6">
                <div className="grid gap-2">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    required
                    autoFocus
                    tabIndex={1}
                    autoComplete="email"
                    placeholder="email@ejemplo.com"
                  />
                  <InputError messages={errors.email} />
                </div>

                <div className="grid gap-2">
                  <div className="flex items-center">
                    <Label htmlFor="password">Contraseña</Label>
                    <TextLink
                      href={newIdentityPasswordResetPath()}
                      className="ml-auto text-sm"
                      tabIndex={5}
                    >
                      ¿Olvidaste tu contraseña?
                    </TextLink>
                  </div>
                  <Input
                    id="password"
                    type="password"
                    name="password"
                    required
                    tabIndex={2}
                    autoComplete="current-password"
                    placeholder="Contraseña"
                  />
                  <InputError messages={errors.password} />
                </div>

                <Button
                  type="submit"
                  variant="cta"
                  className="mt-4 w-full"
                  tabIndex={4}
                  disabled={processing}
                >
                  {processing && <Spinner />}
                  Iniciar sesión
                </Button>
              </div>

              <div className="text-muted-foreground text-center text-sm">
                ¿No tenés cuenta?{" "}
                <TextLink href={signUpPath()} tabIndex={5}>
                  Registrate
                </TextLink>
              </div>
            </>
          )}
        </Form>
      </div>
    </AuthLayout>
  )
}
